////////LIBRARY/////////
import { cloneDeep, find, findIndex, get, isEmpty, isNull, isUndefined, map } from 'lodash'
import React, { Fragment, useState } from 'react'
import { useSelector } from 'react-redux'
///////COMPONENTS///////
import {
	BodyCells,
	BodyCellsSticky,
	BodyCellsToggler,
	ToggleNestedIconWrapper,
	ToggleNestedIcon,
	SkeletonActionWrapper,
} from '../../../../theme/GlobalCss'
import IsAction from '../IsAction'
import IsVisible from '../IsVisible'
import TableRows from '../TableRows'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
/////////ASSETS/////////
import nestedDropDownIcon from '../../../../assets/icones/table/nested-dropdown.svg'

const CellsSticky = ({ row, column, children, stateToggleActions, setStateToggleActions, indexRow, dataSize, ...rest }) => {
	return (
		<BodyCellsSticky toggledAction={stateToggleActions}>
			{row.rowTableSkeleton ? (
				<Skeleton circle count={3} wrapper={SkeletonActionWrapper} />
			) : (
				<column.component
					row={row}
					column={column}
					stateToggleActions={stateToggleActions}
					setStateToggleActions={setStateToggleActions}
					indexRow={indexRow}
					dataSize={dataSize}
					{...rest}
				/>
			)}
		</BodyCellsSticky>
	)
}
const Cells = (props) => {
	let checkifRowNull = get(props.row, props.column.dataHook, '-')
	checkifRowNull = !isNull(checkifRowNull) && !isEmpty(checkifRowNull) ? checkifRowNull : '-'

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<BodyCells>
			{props.row.rowTableSkeleton ? (
				!props.column.useCustomSkeleton && <Skeleton />
			) : props.renderProps ? (
				<props.renderProps
					row={props.row}
					column={props.column}
					stateToggleNested={props.stateToggleNested} /*setStateToggleNested={props.setStateToggleNested}*/
				/>
			) : (
				checkifRowNull.toString()
			)}
		</BodyCells>
	)
}

const TableNestedRows = (props) => {
	const [stateToggleActions, setStateToggleActions] = useState(false)

	const { user } = useSelector((state) => ({
		user: state.user,
	}))

	// Sanitize the eval calls
	const toggleLineEvalHandler = (_o, obj1, obj2) => {
		return eval(`_o.${obj1} === ${obj2}`)
	}

	const propsRowEvalHandler = (_propsRow, obj1) => {
		return eval(`_propsRow.${obj1}`)
	}

	const handleToggleLine = (rowId, stateNested, dataPointer, getter, currentNestedData) => {
		// Cloning current tableData
		let leTableData = cloneDeep(props.dataRef)

		const fIndex = findIndex(leTableData, (o) => toggleLineEvalHandler(o, dataPointer, rowId))

		if (fIndex > -1) {
			leTableData[fIndex].toggleNested = stateNested
		}

		// If user is asking for nested line and nested line is empty, back call
		if (stateNested && isNull(currentNestedData) && !isUndefined(getter)) {
			props.setForceUnsort(true)
			getter(leTableData[fIndex])
		} else {
			// Else we also block sort and only changing toggleNested value
			props.setForceUnsort(true)
			props.tableDataSetter(leTableData)
		}

		// Blocking sort, because when we will change tableData values, it would trigger sorting
	}

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<Fragment>
			<TableRows key={props.id}>
				{props.checkboxConf &&
					!props.editing && // if check box is config and mass edit is not active
					(props.row.tableSkeleton ? (
						<BodyCells>
							<Skeleton circle wrapper={SkeletonActionWrapper} />
						</BodyCells>
					) : (
						<BodyCells>
							<input
								type="checkbox"
								name={props.indexRow}
								ref={props.register}
								value={JSON.stringify(props.row)} // put object typed to string in value of checkbox form ( getValues() )
								onClick={(e) => props.handleCheckValues(e.target.value)}
								checked={find(props.storedChecks, (o) => JSON.stringify(props.row) === o) ? true : false}
							/>
						</BodyCells>
					))}
				{props.nestedValues?.value && (
					<BodyCellsToggler
						//canToggle={!isEmpty(propsRowEvalHandler(props.row, props.nestedValues.nestedData))}
						onClick={() => {
							return !isEmpty(propsRowEvalHandler(props.row, props.nestedValues.nestedData)) ||
								isNull(propsRowEvalHandler(props.row, props.nestedValues.nestedData))
								? handleToggleLine(
										eval(`${props.nestedValues.nestedPointerValuePath}`),
										isUndefined(propsRowEvalHandler(props.row, props.nestedValues.toggleAllNestedPointer))
											? true
											: !propsRowEvalHandler(props.row, props.nestedValues.toggleAllNestedPointer),
										props.nestedValues?.nestedPointer,
										props.nestedValues?.nestedUnitCall,
										propsRowEvalHandler(props.row, props.nestedValues.nestedData)
								  )
								: null
						}}
					>
						{(!isEmpty(propsRowEvalHandler(props.row, props.nestedValues.nestedData)) ||
							isNull(propsRowEvalHandler(props.row, props.nestedValues.nestedData))) && (
							<ToggleNestedIconWrapper>
								<ToggleNestedIcon
									src={nestedDropDownIcon}
									dropped={propsRowEvalHandler(props.row, props.nestedValues.toggleAllNestedPointer)}
								/>
							</ToggleNestedIconWrapper>
						)}
					</BodyCellsToggler>
				)}

				{map(props.columns, (column, id) => {
					let actionAuthorized = true

					const f = find(user.identity.rolePrivileges.privileges, (o) => o.label === column.checkRight) ? true : false
					if (!isUndefined(column.checkRight) && !f && column.action) {
						actionAuthorized = false
					}
					return actionAuthorized ? (
						<IsVisible key={id} isVisible={column.visibility}>
							<IsAction
								isAction={column.action || false}
								data={{ row: props.row, column: column }}
								actionCell={(data) => (
									<CellsSticky
										row={data.row}
										column={data.column}
										stateToggleActions={stateToggleActions}
										setStateToggleActions={setStateToggleActions}
										indexRow={props.indexRow}
										dataSize={props.dataSize}
										{...column.rest}
									>
										{column.component}
									</CellsSticky>
								)}
								normalCell={(data) => (
									<Cells
										row={data.row}
										column={data.column}
										renderProps={column.component}
										stateToggleNested={eval(`props.row.${props.nestedValues?.toggleAllNestedPointer}`)}
									/>
								)}
							/>
						</IsVisible>
					) : null
				})}
			</TableRows>
			{!isEmpty(eval(`props.row.${props.nestedValues?.nestedData}`)) && eval(`props.row.${props.nestedValues?.toggleAllNestedPointer}`) && (
				<TableRows key={props.id}>
					{
						<props.nestedValues.nestedComponent
							row={props.row}
							colspan={props.columns.length}
							stateToggleNested={propsRowEvalHandler(props.row, props.nestedValues.toggleAllNestedPointer)}
						/>
					}
				</TableRows>
			)}
		</Fragment>
	)
}

TableNestedRows.propTypes = {}

TableNestedRows.defaultPropTypes = {}

export default TableNestedRows
